import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import axios from "axios";
import toast from "react-hot-toast";
import { Button, Modal } from "react-bootstrap";
import { dateInDMY, hasRight, isAdmin,hasRightNoAdmin } from "../../Helpers";
import { SERVER_API } from "../../fileWithConstants";
import { useAuth } from "../../context/auth";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import { FaExclamationCircle, FaRegCheckCircle } from "react-icons/fa";
import PoInwarddetails from "./PoInwarddetails";
const InwardPoList = () => {
  const [auth, setAuth] = useAuth();
  const [userId, setUserId] = useState(auth.user.id);
  const admin_right = isAdmin(auth.user);
  const unique_no_right = hasRight(auth.user, "po_unique_no");
  const fabric_in_approve_right = hasRight(auth.user, "fabric_in_approve");
  const po_invoice_approve = hasRight(auth.user, "po_invoice_approve");
  const inw_date_hide = hasRight(auth.user, "inw_date_hide");
  const inw_approve = hasRight(auth.user, "inw_approve");
  const invoice_code_show = hasRightNoAdmin(auth.user, "invoice_code_show");
  const check_show = hasRightNoAdmin(auth.user, "check_show");
  const status_show = hasRightNoAdmin(auth.user, "status_show");

  const [podata, setPodata] = useState([]);
  const [poshow, setPoshow] = useState(false);
  const [selected_po_id, setSelected_po_id] = useState("");
  const [selected_invoice, setSelected_invoice] = useState("");
  const [poChildData, setPoChildData] = useState([]);
  const [podatashow, setPodatashow] = useState(false);

  const [invoiceApproveShow, setInvoiceApproveShow] = useState(false);
  const [invoiceApproveId, setInvoiceApproveId] = useState("");
  const [invoiceApproveNo, setInvoiceApproveNo] = useState("");
  const [invoiceApproving, setInvoiceApproving] = useState(false);

  const [generatedInvoiceCode, setGeneratedInvoiceCode] = useState("");
  const [invoiceApproved, setInvoiceApproved] = useState(false);

  const getPoInwarddata = async () => {
    try {
      const { data } = await axios.get(
        `${SERVER_API}/api/v1/supplier/get-inward-po-data`,
      );
      if (data?.success && data?.podata.length > 0) {
        setPodata(data?.podata);
      } else {
        toast.error("Some thing went wrong while getting PO data.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPoInwarddata();
  }, []);

  const HandleApproveModel = (id, po_number) => {
    if (!fabric_in_approve_right && !admin_right) {
      alert("You have no right to approve.");
      return false;
    }
    setSelected_po_id(id);
    setSelected_invoice(po_number);
    setPoshow(true);
  };

  const handleClose = () => {
    setPoshow(false);
    setPodatashow(false);
  };

  const handleApprove = async () => {
    const formData = new FormData();
    formData.append("inw_id", selected_po_id);
    formData.append("user_id", userId);
    const { data } = await axios.put(
      `${SERVER_API}/api/v1/supplier/po-inward-approve`,
      formData,
      {
        headers: { "Content-Type": "application/json" },
      },
    );
    if (data?.success) {
      toast.success(data.message);
      getPoInwarddata();
      setPoshow(false);
    }
  };

  const handleShowPodata = async (id, invoice_no) => {
    //alert(id); return false;
    //setSelected_po_id(id)
    // selected_invoice
    setPodatashow(true);
    setSelected_invoice(invoice_no);
    const { data } = await axios.get(
      `${SERVER_API}/api/v1/supplier/get-single-inw-po-data/${id}`,
    );
    //console.log(data)
    if (data?.success && data?.posingledata.length > 0) {
      setPoChildData(data?.posingledata);
    } else {
      toast.error("Some thing went wrong while getting PO inward data.");
    }
    setPodatashow(true);
  };

  const handleInvoiceApprove = async () => {
    try {
      setInvoiceApproving(true);

      const formData = {
        inw_id: invoiceApproveId,
        user_id: userId,
      };

      const { data } = await axios.put(
        `${SERVER_API}/api/v1/supplier/po-invoice-approve`,
        formData,
      );

      if (data?.success) {
        setGeneratedInvoiceCode(data.invoice_code || "");
        setInvoiceApproved(true);

        toast.success(data.message || "Invoice approved successfully.");

        await getPoInwarddata();
      } else {
        toast.error(data?.message || "Failed to approve invoice.");
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.message ||
          "Something went wrong while approving invoice.",
      );
    } finally {
      setInvoiceApproving(false);
    }
  };

  const HandleInvoiceApproveModel = (id, invoice_no) => {
    if (!po_invoice_approve && !admin_right) {
      alert("You have no right to approve invoice.");
      return;
    }

    setInvoiceApproveId(id);
    setInvoiceApproveNo(invoice_no);
    setInvoiceApproveShow(true);
  };

 const handleVerifyInvoiceCode = async (po) => {
    try {
        const { data } = await axios.put(
            `${SERVER_API}/api/v1/supplier/verify-invoice-code`,
            {
                inw_id: po.id,
                invoice_code: po.invoice_code,
                user_id: userId,
            }
        );

        if (data?.success) {
            toast.success(data.message);
            await getPoInwarddata();
        } else {
            toast.error(data?.message || 'Invoice verification failed.');
        }
    } catch (error) {
        console.error(error);
        toast.error(
            error.response?.data?.message ||
            'Error verifying invoice code.'
        );
    }
};

  return (
    <Layout title={"Po Inward List Page"}>
      <div className="container">
        <div className="justify-content-center">
          <h1 className="page-title text-center">PO Inward List</h1>
          <div className="row">
            <div className="col-md-12">
              <div className="table-box">
                <table className="table table-responsive table-hover table-sticky">
                  <thead>
                    <tr className="align-item">
                      <th scope="col">#</th>
                      <th scope="col" className="text-center">
                        Invoice No.
                      </th>
                      <th scope="col" className="text-center">
                        Invoice Date
                      </th>
                      <th scope="col" className="text-center">
                        Amount
                      </th>
                      {!inw_date_hide && (
                        <th scope="col" className="text-center">
                          Inward Date
                        </th>
                      )}

                      {invoice_code_show && (
                        <th scope="col" className="text-center">
                          Invoice Code
                        </th>
                      )}

                      {status_show && (
                      <th scope="col" className="text-center">
                        Status
                      </th>
                       )}

                       {check_show && (
                        <th scope="col" className="text-center">
                          Check
                        </th>
                      )}
                                          
                      </tr>

                  </thead>
                  <tbody>
                    {podata?.map((po, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td
                          className="text-start"
                          onClick={() => {
                            handleShowPodata(po.id, po.invoice_no);
                          }}
                        >
                          <Link to={"#"}>{po.invoice_no}</Link>
                        </td>
                        <td className="text-center">
                          {dateInDMY(po.invoice_date)}
                        </td>
                        <td className="text-center">{po.invoice_amount}</td>
                        {!inw_date_hide && (
                            <td className="text-center">{dateInDMY(po.inw_at)}</td>
                        )}
                        {invoice_code_show && (
                            <td className="text-center">
                                {po.invoice_code ? (
                                    <span
                                        role="button"
                                        style={{ cursor: 'pointer' }}
                                        className={
                                            Number(po.invoice_code_verified) === 1
                                                ? 'text-success fw-bold'
                                                : 'text-primary text-decoration-underline'
                                        }
                                        onClick={() => {
                                            if (Number(po.invoice_code_verified) !== 1) {
                                                handleVerifyInvoiceCode(po);
                                            }
                                        }}
                                        title={
                                            Number(po.invoice_code_verified) === 1
                                                ? 'Invoice code verified'
                                                : 'Click to verify invoice code'
                                        }
                                    >
                                        {Number(po.invoice_code_verified) === 1 && '✓ '}
                                        {po.invoice_code}
                                    </span>
                                ) : (
                                    '-'
                                )}
                            </td>
                        )}

                         {status_show && (
                        <td className="text-center">
                          {Number(po.approve_status) === 1 ? (
                            Number(po.invoice_status) === 1 ? (
                              <span>
                                <FaRegCheckCircle className="text-success" />{" "}
                                {po.invoice_code}
                              </span>
                            ) : (
                              <span
                                role="button"
                                onClick={() =>
                                  HandleInvoiceApproveModel(po.id, po.invoice_no)
                                }
                              >
                                <FaExclamationCircle className="text-danger" />{" "}
                                Pending
                              </span>
                            )
                          ) : (
                            "--"
                          )}
                        </td>
                         )}
                        
                         {check_show && (
                        <td className="text-center">
                          {po.approve_status === 1 ? (
                            <Link to={"#"}>
                              <span>
                                <FaRegCheckCircle className="text-success" />{" "}
                                Approved
                              </span>
                            </Link>
                          ) : (
                            <Link to={"#"}>
                              <span
                                onClick={() => {
                                  HandleApproveModel(po.id, po.invoice_no);
                                }}
                              >
                                <FaExclamationCircle className="text-danger" />{" "}
                                Pending
                              </span>
                            </Link>
                          )}
                        </td>
                          )} 
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={poshow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Invoice number: {selected_invoice}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FaExclamationCircle className="text-warning" /> Are you sure, you
          want to approve Invoice number: <b>{selected_invoice}</b> ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleApprove}>
            Yes
          </Button>
          <Button variant="danger" onClick={handleClose}>
            No
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={invoiceApproveShow}
        onHide={() => {
          setInvoiceApproveShow(false);
          setInvoiceApproved(false);
          setGeneratedInvoiceCode("");
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Invoice number: {invoiceApproveNo}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {invoiceApproved ? (
            <div className="text-center">
              <FaRegCheckCircle className="text-success mb-3" size={40} />

              <h5 className="text-success">Invoice Approved Successfully!</h5>

              <p className="mb-2">Your Invoice Code</p>

              <h2 className="fw-bold text-primary">
                {generatedInvoiceCode || "No invoice code returned"}
              </h2>

              {generatedInvoiceCode && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => {
                    navigator.clipboard.writeText(generatedInvoiceCode);
                    toast.success("Invoice code copied!");
                  }}
                >
                  Copy Invoice Code
                </Button>
              )}
            </div>
          ) : (
            <>
              <FaExclamationCircle className="text-warning" /> Are you sure you
              want to approve invoice number: <b>{invoiceApproveNo}</b>?
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          {!invoiceApproved ? (
            <>
              <Button
                variant="success"
                onClick={handleInvoiceApprove}
                disabled={invoiceApproving}
              >
                {invoiceApproving ? "Approving..." : "Yes, Approve Invoice"}
              </Button>

              <Button
                variant="danger"
                onClick={() => setInvoiceApproveShow(false)}
                disabled={invoiceApproving}
              >
                Cancel
              </Button>
            </>
          ) : (
            <Button
              variant="secondary"
              onClick={() => {
                setInvoiceApproveShow(false);
                setInvoiceApproved(false);
                setGeneratedInvoiceCode("");
              }}
            >
              Close
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal size="lg" show={podatashow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Invoice number: {selected_invoice}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PoInwarddetails poChildData={poChildData} />
        </Modal.Body>
      </Modal>
    </Layout>
  );
};

export default InwardPoList;
